export default "__VITE_ASSET__BIVoQv6g__"